import { BaseComponent } from "./base-component";
import { Mode } from 'src/core/utility/enums/enums';
import { CONSTANTS } from 'src/core/utility/const/const';

export abstract class ListingBaseComponent extends  BaseComponent {
    //#region Properties
    public pageSize: number = CONSTANTS.pageSize;
    public maxpagesNumber:number = CONSTANTS.maxPagesNumber;
    public total:number;
    public currentPageNumber:number = 0;
    public hasNext: boolean = false ;
    //#endregion

    //#region Methods
    onSuccess = (list: Array<any>) => {
        //alert('base');
        this.ngZone.run(() => {
            this.LoadingScreenService.stopLoading();
            this.status = Mode.Success;
            this.list = list;
            this.total = list.length;
        });

    }

    onSuccessPaging = (data:any) => {
        this.ngZone.run(() => {
            this.LoadingScreenService.stopLoading();
            this.status = Mode.Success;
            this.list = this.list.concat(data.Items);
            this.hasNext = data.hasNext;
            this.total = this.list.length;
        });
      }

   
    pageChanged(pageNumber: number): void {
        this.currentPageNumber = pageNumber;
    }

    //#endregion
}